import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from './Dialog';
import { dialogSelector } from 'redux/alerts/selectors';
import { hideDialog } from 'redux/alerts/actions';

const DialogContainer = () => {
    const config = useSelector(dialogSelector);
    const dispatch = useDispatch();

    const handleClose = () => {
        dispatch(hideDialog());
    };

    return <Dialog {...config} handleClose={handleClose} />;
};

export default DialogContainer;
